import React from "react";
import { motion } from "framer-motion";

export default function PageHeader({ eyebrow, title, subtitle, align = "left", children }) {
    const alignment = align === "center" ? "text-center mx-auto" : "text-left";
    return (
        <section
            className="bg-gradient-to-b from-white to-mm-bg border-b border-mm-line"
            data-testid="page-header"
        >
            <div className="mm-container py-16 sm:py-24">
                <motion.div
                    initial={{ opacity: 0, y: 14 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className={`max-w-3xl ${alignment}`}
                >
                    {eyebrow && <div className="mm-eyebrow mb-4">{eyebrow}</div>}
                    <h1 className="mm-display text-4xl sm:text-5xl lg:text-6xl text-mm-navy">
                        {title}
                    </h1>
                    {subtitle && (
                        <p className="mt-5 text-base sm:text-lg text-mm-muted leading-relaxed max-w-2xl">
                            {subtitle}
                        </p>
                    )}
                    {children && <div className="mt-7">{children}</div>}
                </motion.div>
            </div>
        </section>
    );
}
